/******/ (() => { // webpackBootstrap
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-selector="back-to-top-button"]');
    this.lastScrollPosition = window.pageYOffset;
    this._rafId = 0;
    this._cachedInnerHeight = window.innerHeight;
    this._isDesktop = true;
    this._boundHandleScroll = this.handleScroll.bind(this);
    this._boundOnResize = this._onResize.bind(this);
  }

  connectedCallback() {
    this._desktopMql = window.matchMedia('screen and (max-width: 767px)');
    this._isDesktop = !this._desktopMql.matches;
    this._desktopMql.addEventListener('change', (e) => { this._isDesktop = !e.matches; });
    this.attachEvents();
    this.handleDisplay(this._isDesktop);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._boundHandleScroll);
    window.removeEventListener('resize', this._boundOnResize);
    if (this._rafId) cancelAnimationFrame(this._rafId);
  }

  attachEvents() {
    window.addEventListener('scroll', this._boundHandleScroll, { passive: true });
    window.addEventListener('resize', this._boundOnResize, { passive: true });
    this.button.addEventListener('click', this.scrollToTop.bind(this));
    this.button.addEventListener('focus', this.showButton.bind(this));
  }

  _onResize() {
    this._cachedInnerHeight = window.innerHeight;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: this.scrollBehavior });
    this.button.blur();
  }

  handleScroll() {
    if (this._rafId) return;
    this._rafId = requestAnimationFrame(() => {
      this._rafId = 0;
      const currentScrollPosition = window.pageYOffset;
      const scrollingUp = currentScrollPosition < this.lastScrollPosition;
      this.handleDisplay(this._isDesktop, scrollingUp, currentScrollPosition);
      this.lastScrollPosition = currentScrollPosition <= 0 ? 0 : currentScrollPosition;
    });
  }

  handleDisplay(isDesktop, scrollingUp, scrollY) {
    const showButton = isDesktop || scrollingUp;
    if (scrollY > this._cachedInnerHeight && showButton) {
      this.showButton();
      window.eventBus.emit('back-to-top:visible');
    } else {
      this.hideButton();
      window.eventBus.emit('back-to-top:hidden');
    }
  }

  showButton() {
    if (this.classList.contains('back-to-top--visible')) return;
    this.classList.add('back-to-top--visible');
  }

  hideButton() {
    if (!this.classList.contains('back-to-top--visible')) return;
    this.classList.remove('back-to-top--visible');
  }

  get scrollBehavior() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    return prefersReducedMotion.matches ? 'auto' : 'smooth';
  }
}

customElements.define('back-to-top', BackToTop);

/******/ })()
;